import { Injectable } from '@angular/core';
import { CreditCardType, NumericCreditCardType } from 'core/constants';

@Injectable()
export class CardTypeService {

    public translateCardType(numericCardType: string): string {
        switch (numericCardType) {
            case NumericCreditCardType.AMEX:
                return CreditCardType.AMEX;
            case NumericCreditCardType.VISA:
                return CreditCardType.VISA;
            case NumericCreditCardType.MASTER_CARD:
                return CreditCardType.MASTER_CARD;
            case NumericCreditCardType.DISCOVER:
                return CreditCardType.DISCOVER;
        }
    }
}
